<app-product
  [photo]="book.menuPhoto"
  [caption]="book.caption"
  [summary]="book.summary"
  [notice]="book.notice"
  [price]="$any(book.prices[0]?.[1])"
  [discount]="discountService.getDiscount$(book.alias) | async"
  (buttonClick)="onButtonClick()"
></app-product>
